var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-app',{attrs:{"params":_vm.f7Params}},[_c('f7-panel',{attrs:{"left":"","reveal":""}},[_c('f7-view',{attrs:{"url":"/panel-left/","links-view":".view-main"}})],1),_c('f7-view',{staticClass:"safe-areas",attrs:{"url":"/","animate":false,"main":true,"iosSwipeBack":false,"pushState":false,"master-detail-breakpoint":800}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }